import { UsersAndGroupsTabs } from './components';
import { activeTab, queryParamsInitial, setSearchParamsToState } from './store';
import { AccessGroupsView, AdministratorsView, UsersView } from './views';
import EditAccessGroup from './pages/EditAccessGroup';
import EditUser from './pages/EditUser';
import { getFiltersFromSearchParams } from '@/utils';
import { Box } from '@servicepipe/ui-components';
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

const UsersAndGroups = () => {
  const { userId, groupId } = useParams();
  const [searchParams] = useSearchParams();
  const [queryParams, setQueryParams] = useState({
    ...queryParamsInitial,
    filters: getFiltersFromSearchParams(Object.fromEntries([...searchParams])),
  });

  useEffect(() => {
    setSearchParamsToState(searchParams, setQueryParams, queryParamsInitial);
  }, [searchParams]);

  if (userId) {
    return <EditUser />;
  }

  if (groupId) {
    return <EditAccessGroup />;
  }

  return (
    <Box width="100%" minWidth="0" direction="column" padding="0" gap="35px">
      <UsersAndGroupsTabs queryParams={queryParams} />

      <UsersView isShowTable={queryParams.tab === activeTab.users} />
      <AdministratorsView isShowTable={queryParams.tab === activeTab.administrators} />
      <AccessGroupsView isShowTable={queryParams.tab === activeTab.accessGroups} />
    </Box>
  );
};

export default UsersAndGroups;
